import { Environment } from '../environment';

/*
  This regex will return this
  [hostname, subdomain, tenantSlug, domain]

  we add a fallback because on unit tests window.location does not exists
*/
const tenantSlugIndex = 2;
const domainIndex = 3;

function url() {
  const urlParts = window?.location?.hostname?.match(/^((.+)\.)?(.+\.io)$/) || [];
    
  const domain = urlParts[domainIndex];
  const tenantSlug = urlParts[tenantSlugIndex];

  return { domain, tenantSlug }
}

export const getPort: () => string = () => window?.location?.port;

export const getUrlWithProtocolTenantAndDomain: () => string = () => window?.location?.origin;

export const getUrlWithTenantAndDomain: () => string = () => window?.location?.hostname;

export const getDomain: () => string = () => url().domain;

export const getTenantSlug: () => string = () => url().tenantSlug;

/**
 * we check the end of the domain to return the current environment
 *
 * @returns
 */
export const getEnvironment: () => Environment = () => {
  /**
   * If we don't have domain then it is admin app as we have different
   * url pattern.
   */
  if (!url().domain) {
    return getAdminAppEnvironemnt();
  }

  if (url().domain.endsWith('-test.io')) {
    return Environment.test;
  }

  if (url().domain.endsWith('-stage.io')) {
    return Environment.stage;
  }

  return Environment.live;
};

/**
 * Provides environment for admin app.
 *
 * @returns - Return the environment type
 */
export const getAdminAppEnvironemnt = (): Environment => {
  const domain: string = window?.location?.hostname?.match(/^((.+)\.)?(.+-admin.com)$/)?.[domainIndex];

  // If no domain we throw error.
  if (!domain) {
    throw new Error('Neither the itonics.io nor admin.com domain detected');
  }

  if (domain.endsWith('-test-admin.com')) {
    return Environment.test;
  }

  if (domain.endsWith('-stage-admin.com')) {
    return Environment.stage;
  }

  return Environment.live;
};
